import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PagesEventService, Utilities, Url } from "src/app/common";
import { User, UserAuth } from "src/app/common/user-auth";
import { EventEmitterService } from "../../project/services/event-emitter.service";
import { gridColumns } from "../models/grid-columns.model";
import { Ticket } from "../models/ticket.model";
import { TicketService } from "../services/ticket.service";
import { translateCollection } from "src/app/common/utilities";

@Component({
  selector: 'app-ticket-index',
  templateUrl: '../views/index.component.html',
  styleUrls: ['../styles/style.css']
})
export class IndexComponent implements OnInit {
  userAuth: User = UserAuth.get();
  url = Url;
  tickets = new Ticket();
  gridColumns=gridColumns;
  openModalGroups = false;
  openedClicked = false;
  openAssignedToMe = false;
  openedTickets = null;
  ticketsAssignedToMe = null;
  selectedType = 'Skynet-Ticket';
  statusChecked = null;
  statusOptions = [
    {id:'Offen', name: 'Offen', language:'de'},
    {id:'Geschlossen', name: 'Geschlossen', language:'de'},
    {id:'Archived', name: 'Archiviert', language:'de'},
    {id:'Alle', name: 'Alle', language:'de'},

    {id:'Offen', name: 'Aperto', language:'it'},
    {id:'Geschlossen', name: 'Chiuso', language:'it'},
    {id:'Archived', name: 'Archiviato', language:'it'},
    {id:'Alle', name: 'Tutti', language:'it'},

    {id:'Offen', name: 'Ouvert', language:'fr'},
    {id:'Geschlossen', name: 'Fermé', language:'fr'},
    {id:'Archived', name: 'Archivé', language:'fr'},
    {id:'Alle', name: 'Tous', language:'fr'},

    {id:'Offen', name: 'Open', language:'en'},
    {id:'Geschlossen', name: 'Closed', language:'en'},
    {id:'Archived', name: 'Archived', language:'en'},
    {id:'Alle', name: 'All', language:'en'}
  ];

  constructor(private pagesEventService: PagesEventService,
              private router: Router,
              public eventEmitter: EventEmitterService,
              public ticketService: TicketService) {
  }

  ngOnInit(): void {
    translateCollection(this);
    this.statusChecked = this.statusOptions[0]
    this.pagesEventService.setTitle('Tickets');
    this.pagesEventService.setBreadcrumb([{ name: 'Home', routerLink: '/' }, { name: 'Tickets', routerLink: '/ticket' }]);
    this.getAllTickets();
  }

  statusChanged() {
    this.getAllTickets();
  }

  selectType(type) {
    this.selectedType = type;
    this.getAllTickets();
  }

  getAllTickets() {
    this.ticketService.getAllTickets({statusChecked: this.statusChecked.id, type: this.selectedType}).subscribe((response) => {
      response.Tickets.forEach(element => {
        element.created_at=Utilities.getFormatedDateTimeDDMMYY(element.created_at);
        element.updated_at=Utilities.getFormatedDateTimeDDMMYY(element.updated_at);
      });
      Utilities.parseToDateObject(response.Tickets,gridColumns.filter(a => a.filter == 'date'))
      this.openedTickets = response.TicketsOpened;
      this.tickets = response.Tickets;
      this.getAssignedToMeData();
    });
  }

  getAssignedToMeData() {
    this.ticketService.getAssignedToMe({id: this.userAuth.id, type: this.selectedType}).subscribe((response) => {
      this.ticketsAssignedToMe = response.TicketsAssignedToMe;
    });
  }

  getOpened() {
    this.openedClicked = !this.openedClicked;
    this.openAssignedToMe = false;
    if(this.openedClicked) {
      this.ticketService.getAllOpenedTickets({type: this.selectedType}).subscribe((response) => {
        response.Tickets.forEach(element => {
          element.created_at=Utilities.getFormatedDateTimeDDMMYY(element.created_at);
          element.updated_at=Utilities.getFormatedDateTimeDDMMYY(element.updated_at);
        });
        this.tickets = response.Tickets;
      });
    }
    else {
      this.getAllTickets();
    }
  }

  getAssignedToMe() {
    this.openAssignedToMe = !this.openAssignedToMe;
    this.openedClicked = false;
    if(this.openAssignedToMe) {
      this.ticketService.getAllAssignedToMeTickets({id: this.userAuth.id, type: this.selectedType}).subscribe((response) => {
        response.Tickets.forEach(element => {
          element.created_at=Utilities.getFormatedDateTimeDDMMYY(element.created_at);
          element.updated_at=Utilities.getFormatedDateTimeDDMMYY(element.updated_at);
        });
        this.tickets = response.Tickets;
      });
    }
    else {
      this.getAllTickets();
    }
  }

  onDblClick(row) {
    if (row != null) {
      this.router.navigate(['/ticket/view/', row.id]);
    }
  }

}
